import { render, staticRenderFns } from "./emailColumnViewer.vue?vue&type=template&id=49eccf7b&scoped=true&"
import script from "./emailColumnViewer.vue?vue&type=script&lang=js&"
export * from "./emailColumnViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eccf7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
